import React, { useState, useEffect } from 'react';
import { getProducts } from '../../services/shopify';
import { useCart } from '../../contexts/CartContext';
import ProductCard from '../../components/shop/ProductCard/ProductCard';
import Cart from '../../components/shop/Cart/Cart';

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const { cartCount } = useCart();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const fetchedProducts = await getProducts(20);
        setProducts(fetchedProducts);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <main className="ub-shop-page">
        <div className="ub-shop-container">
          <div className="ub-shop-loading">
            <IconShoppingBag size={64} color="#c41e3a" stroke={1.5} />
            <p>Loading products...</p>
          </div>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="ub-shop-page">
        <div className="ub-shop-container">
          <div className="ub-shop-error">
            <IconShoppingBag size={64} color="#c41e3a" stroke={1.5} />
            <p>{error}</p>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="ub-shop-page">
      <div className="ub-shop-container">
        <div className="ub-shop-header">
          <h1 className="ub-shop-title">UBsports Pro Shop</h1>
          <p className="ub-shop-subtitle">
            Premium sports gear and exclusive merchandise
          </p>
        </div>

        {products.length === 0 ? (
          <div className="ub-shop-empty">
            <IconShoppingBag size={64} color="#c41e3a" stroke={1.5} />
            <p>No products available at the moment</p>
          </div>
        ) : (
          <div className="ub-products-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={() => setCartOpen(true)}
              />
            ))}
          </div>
        )}

        <Cart isOpen={cartOpen} onClose={() => setCartOpen(false)} />

        {cartCount > 0 && (
          <button
            className="ub-floating-cart-btn"
            onClick={() => setCartOpen(true)}
            aria-label="View cart"
          >
            <IconShoppingBag size={24} stroke={2} />
            <span className="ub-cart-badge">{cartCount}</span>
          </button>
        )}
      </div>
    </main>
  );
};

export default Shop;
